/**
 * Returns the device's IANA timezone name (e.g. "Australia/Sydney"), or null
 * if the runtime can't resolve one. `resolvedOptions().timeZone` only ever
 * yields IANA names, never fixed offsets like "GMT+10".
 */
export const getDeviceTimezone = (): string | null => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
};
